const SidebarData = [
  {
    ID_Menu: 98,
    Nome_Item: "Ui Lab",
    Icone_Item: "bx bx-star",
    Disponivel: "S",
    Codigo_Transacao: "ui",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    badgeValue: "3",
    Menu_Interno: "S",
    Descricao_Item:
      "Este menu fornece todos os componentes disponíveis no sistema para auxiliar o desenvolvedor em novas implementações. (Visível apenas no ambiente de desenvolvimento) ",
    TopBarInternalMenu: [
      {
        ID_Menu_Pai: 98,
        ID_Menu: 1,
        Transacao: "UI Components",
        active: true,
        Icone_Transacao: "mdi mdi-briefcase-variant-outline",
        URL_Transacao: "",
        Dropdown: "S",
        childrens: [
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Alerts",
            URL_Transacao: "ui-alerts",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Badge",
            URL_Transacao: "ui-badge",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Breadcrumb",
            URL_Transacao: "ui-breadcrumb",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Buttons",
            URL_Transacao: "ui-buttons",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Cards",
            URL_Transacao: "ui-cards",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Carousel",
            URL_Transacao: "ui-carousel",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Dropdowns",
            URL_Transacao: "ui-dropdowns",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Grid",
            URL_Transacao: "ui-grid",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Images",
            URL_Transacao: "ui-images",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Lightbox",
            URL_Transacao: "ui-lightbox",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Modals",
            URL_Transacao: "ui-modals",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Offcanvas",
            URL_Transacao: "ui-offcanvas",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Rangeslider",
            URL_Transacao: "ui-rangeslider",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Sessiontimeout",
            URL_Transacao: "ui-sessiontimeout",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Pagination",
            URL_Transacao: "ui-pagination",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Progressbars",
            URL_Transacao: "ui-progressbars",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Placeholders",
            URL_Transacao: "ui-placeholders",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Tabs Accordions",
            URL_Transacao: "ui-tabs-accordions",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Typography",
            URL_Transacao: "ui-typography",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Toasts",
            URL_Transacao: "ui-toasts",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Video",
            URL_Transacao: "ui-video",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Popovers",
            URL_Transacao: "ui-popovers",
          },
          {
            ID_Menu_Pai: 1,
            Transacao: "UI Rating",
            URL_Transacao: "ui-rating",
          },
        ],
      },
      {
        ID_Menu_Pai: 98,
        ID_Menu: 2,
        Transacao: "Forms",
        active: true,
        Icone_Transacao: "ri-eraser-fill",
        URL_Transacao: "",
        Dropdown: "S",
        childrens: [
          {
            ID_Menu_Pai: 2,
            Transacao: "Form custom",
            URL_Transacao: "form-custom",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form elements",
            URL_Transacao: "form-elements",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form validation",
            URL_Transacao: "form-validation",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form Advanced",
            URL_Transacao: "form-advanced",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form Editor",
            URL_Transacao: "form-editor",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form Uploads",
            URL_Transacao: "form-uploads",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form Editors",
            URL_Transacao: "form-editors",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form Wizard",
            URL_Transacao: "form-wizard",
          },
          {
            ID_Menu_Pai: 2,
            Transacao: "Form Mask",
            URL_Transacao: "form-mask",
          },
        ],
      },
      {
        ID_Menu_Pai: 98,
        ID_Menu: 3,
        Transacao: "Tables",
        active: true,
        Icone_Transacao: "ri-table-2",
        URL_Transacao: "",
        Dropdown: "S",
        childrens: [
          {
            Transacao: "Tables Basic",
            URL_Transacao: "tables-basic",
          },
          {
            Transacao: "Tables Listjs",
            URL_Transacao: "tables-listjs",
          },
          {
            Transacao: "Tables Datatables",
            URL_Transacao: "table-datatables",
          },
        ],
      },
      {
        ID_Menu_Pai: 98,
        ID_Menu: 4,
        Transacao: "Charts",
        active: true,
        Icone_Transacao: "ri-bar-chart-line",
        URL_Transacao: "",
        Dropdown: "S",
        childrens: [
          {
            Transacao: "Chart Apexcharts",
            URL_Transacao: "chart-apexcharts",
          },
          {
            Transacao: "Chart Chartjscharts",
            URL_Transacao: "chart-chartjscharts",
          },
          {
            Transacao: "Chart Floatcharts",
            URL_Transacao: "chart-floatcharts",
          },
          {
            Transacao: "Chart Jknobcharts",
            URL_Transacao: "chart-jknobcharts",
          },
          {
            Transacao: "Chart Sparklinecharts",
            URL_Transacao: "chart-sparklinecharts",
          },
        ],
      },
      {
        ID_Menu_Pai: 98,
        ID_Menu: 5,
        Transacao: "Icons",
        active: true,
        Icone_Transacao: "ri-brush-line",
        URL_Transacao: "",
        Dropdown: "S",
        childrens: [
          {
            Transacao: "Icon Boxicon",
            URL_Transacao: "icon-boxicon",
          },
          {
            Transacao: "Icons Materialdesign",
            URL_Transacao: "icons-materialdesign",
          },
          {
            Transacao: "Icon Dripicons",
            URL_Transacao: "icon-dripicons",
          },
          {
            Transacao: "Icons Fontawesome",
            URL_Transacao: "icons-fontawesome",
          },
        ],
      },
      {
        ID_Menu_Pai: 98,
        ID_Menu: 6,
        Transacao: "Maps",
        active: true,
        Icone_Transacao: "ri-map-pin-line",
        URL_Transacao: "",
        Dropdown: "S",
        childrens: [
          {
            Transacao: "Maps Google",
            URL_Transacao: "maps-google",
          },
          {
            Transacao: "Maps Vector",
            URL_Transacao: "maps-vector",
          },
        ],
      },
      {
        ID_Menu_Pai: 98,
        ID_Menu: 7,
        Transacao: "Tools",
        active: true,
        Icone_Transacao: "ri-map-pin-line",
        URL_Transacao: "",
        Dropdown: "S",
        childrens: [
          {
            Transacao: "JSON Tools",
            URL_Transacao: "json-tools",
          }
        ],
      },
    ],
  },
];
export default SidebarData;


